<template>
  <div>
    <vue-headful
      title="Add Students | Dashboard"
      description="Description goes here"
    />
    <div class="add-students-page">
      <!-- PAGE TITLE -->
      <div class="container px-1">
        <div class="row">
          <div class="col-12">
            <div
              :class="[
                account_type === 'school'
                  ? 'dashboard-header-row'
                  : 'dashboard-subheader-row',
              ]"
            >
              <div class="page-title font-weight-bold">Add Students</div>
            </div>
          </div>
        </div>
      </div>

      <!-- STUDENT CLASS ADDUP FORM -->
      <div class="container px-1 form-container">
        <form @submit.prevent>
          <!-- CLASS NAME -->
          <div class="row form-row-group">
            <!-- LABEL -->
            <div class="col-12 col-md-3">
              <label for="className" class="control-label">Class</label>
              <div class="label-info">Class to add students</div>
            </div>

            <!-- INPUT -->
            <div class="col-12 col-md-9">
              <div class="input-group">
                <select
                  id="className"
                  class="form-control form-control-top"
                  v-model="class_name"
                >
                  <option value selected disabled>Select Class</option>
                  <template v-if="classes">
                    <option
                      v-for="(classObj, index) in classes"
                      :key="index"
                      :value="classObj.id"
                    >
                      {{ classObj.class_name }} ({{ classObj.class_code }})
                    </option>
                  </template>
                </select>
              </div>
            </div>
          </div>

          <!-- DEFAULT PASSWORD -->
          <div class="row form-row-group">
            <!-- LABEL -->
            <div class="col-12 col-md-3">
              <label for="defaultPwd" class="control-label"
                >Default Password</label
              >
              <div class="label-info">
                This will be required for your students to log into their
                gradely account.
              </div>
            </div>

            <!-- INPUT -->
            <div class="col-12 col-md-9">
              <div class="input-group">
                <input
                  :type="password_type ? 'password' : 'text'"
                  class="form-control form-control-top"
                  id="defaultPwd"
                  v-model="password"
                  placeholder="Create a default password"
                />
                <span class="input-group-addon show-pwd" @click="showPwd">
                  <i class="pointer cust_icon icon_eye"></i>
                </span>
              </div>
              <span class="font-12 brand_tonic">
                Note: Password should contain 6 characters or more
              </span>
            </div>
          </div>

          <!-- STUDENT INFO FORM -->
          <div class="student-info-form overflow-auto">
            <div class="student-table">
              <div class="student-header"></div>
              <div class="student-body"></div>
            </div>

            <table class="table">
              <thead>
                <tr>
                  <td class="first-row"></td>
                  <td class="font-weight-bold font-14 color_grey_dark">
                    STUDENT NAME
                  </td>
                  <td class="font-weight-bold font-14 color_grey_dark">
                    EMAIL ADDRESS
                    <span
                      class="hint--top hint--primary hint--midlg hint--rounded"
                      aria-label="We recommend adding the parent’s email address"
                    >
                      <i class="icon-info red-text ml-2 pointer"></i>
                    </span>
                  </td>
                  <td class="font-weight-bold font-14 color_grey_dark">
                    PHONE NUMBER
                    <span
                      class="hint--top hint--primary hint--midlg hint--rounded"
                      aria-label="We recommend adding the parent’s phone number"
                    >
                      <i class="icon-info red-text ml-2 pointer"></i>
                    </span>
                  </td>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(student, index) in number_of_students" :key="index">
                  <td
                    class="first-row text-center d-flex justify-content-center align-items-center"
                  >
                    <div class="avatar">
                      <div class="avatar-text color_grey_dark">
                        {{ index + 1 }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <input
                      required
                      type="text"
                      v-model="student_form[index].name"
                      class="form-control"
                      placeholder="First name, Last name or Student Code"
                    />
                    <div
                      class="btn-link cancel-link select-none"
                      v-if="showCancelButton(index)"
                      @click="removeLastStudentInput"
                    >
                      Cancel
                    </div>
                  </td>
                  <td>
                    <input
                      type="email"
                      v-model="student_form[index].email"
                      class="form-control"
                      placeholder="Email Address"
                    />
                  </td>
                  <td>
                    <input
                      type="tel"
                      v-model="student_form[index].phone"
                      maxlength="11"
                      class="form-control"
                      placeholder="Phone Number"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- ADD ANOTHER STUDENT -->
          <div class="add-new-item pointer">
            <div class="undone"></div>
            <div
              class="label-text font-weight-bold brand_accent"
              @click="addField"
            >
              Add another Student
            </div>
          </div>

          <!-- FORM DIVIDER -->
          <div class="form-divider"></div>

          <div
            class="form-group d-flex justify-content-center align-items-center mb-5"
          >
            <button
              class="btn btn-md transparent_bg color_text z-depth-0 mr-3 index-9"
              @click="reloadPage"
            >
              Cancel
            </button>

            <template v-if="is_class_valid">
              <button
                @click="addStudentsAction"
                class="btn btn-md btn-accent ml-3 border"
                type="submit"
                ref="addStudentBtn"
                :disabled="!buttonToggler"
              >
                Add all to Class
              </button>
            </template>
            <template v-else>
              <button
                class="btn btn-sm color_text rounded-20 text-uppercase brand_accent_bg hint--primary hint-rounded hint-top disable-btn-styling border"
                aria-label="Invalid class selected"
              >
                Add all to Class
              </button>
            </template>
          </div>
        </form>
      </div>
      <!-- STUDENT CLASS ADDUP FORM -->

      <!-- STUDENT INVITAION MESSAGE MODAL COMPONENT -->
      <StudentInvitationModal
        v-if="on_success"
        :class_id="Number(class_name)"
        :account="account_type"
        @close-triggered="toggleModal"
        @clear-out-form="reloadPage"
      ></StudentInvitationModal>
      <!-- STUDENT INVITAION MESSAGE MODAL COMPONENT -->

      <!-- NO SUBSCRIPTION MODAL -->
      <SubscriptionExpiredModal
        v-if="show_no_subscription"
        @closeTriggered="toggleSubscriptionModal"
      ></SubscriptionExpiredModal>
      <!-- NO SUBSCRIPTION MODAL -->
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "AddStudents",

  components: {
    StudentInvitationModal: () =>
      import(
        /* webpackChunkName: "StudentInvitationModal" */
        "@/components/modalComps/classModals/StudentInvitationModal"
      ),
    SubscriptionExpiredModal: () =>
      import(
        /* webpackChunkName: "SubscriptionExpiredModal" */
        "@/components/modalComps/classModals/SubscriptionExpiredModal"
      ),
  },

  data() {
    return {
      account_type: "",
      header_margin: "",
      class_name: "",
      password: "",
      classes: null,
      number_of_students: 1,
      student_form: [
        {
          name: "",
          email: "",
          phone: "",
        },
      ],
      password_type: true,
      on_success: false,
      is_class_valid: false,
      show_no_subscription: false,
    };
  },

  mounted() {
    this.getAccountType();
    this.getClassesAction();
  },

  computed: {
    buttonToggler() {
      const empty = [...this.student_form].filter((student) => student.name);
      return (
        empty.length > 0 && this.password.length > 5 && this.class_name !== ""
      );
    },
  },

  watch: {
    class_name: "checkClassValidity",
  },

  methods: {
    ...mapActions([
      "addStudents",
      "getClasses",
      "getSchoolClasses",
      "verifyClassStatus",
    ]),

    showCancelButton(index) {
      if (this.number_of_students > 1)
        return this.number_of_students == index + 1 ? true : false;
      else return false;
    },

    removeLastStudentInput() {
      this.student_form.length--;
      this.number_of_students--;
    },

    showPwd() {
      let pwd_icon = document.querySelector(".show-pwd");
      this.password_type = !this.password_type;
      pwd_icon.classList.toggle("show_pass");
    },

    toggleModal() {
      this.on_success = !this.on_success;
    },

    toggleSubscriptionModal() {
      this.show_no_subscription = !this.show_no_subscription;
    },

    addField() {
      let data = {
        name: "",
        email: "",
        phone: "",
      };

      this.student_form.push(data);
      this.number_of_students++;
    },

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
      if (this.account_type === "school") {
        this.header_margin;
      }
    },

    reloadPage() {
      this.class_name = "";
      this.password = "";
      this.number_of_students = 1;
      this.student_form = [{}];
    },

    addStudentsAction() {
      this.$refs.addStudentBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      this.addStudents({
        class_id: this.class_name,
        password: this.password,
        students: this.student_form,
      }).then((res) => {
        // console.log(res);
        if (res.data.code === 200) {
          setTimeout(() => {
            this.$refs.addStudentBtn.innerText = "Add All To Class";
            this.toggleModal();
          }, 1500);
        } else if (res.data.code === 406) {
          this.toggleSubscriptionModal();
          this.$refs.addStudentBtn.innerText = "Add All To Class";
          this.showError = true;
          let err_msg = res.data.data
            ? res.data.data
            : "An error occured. Try again!";
          this.$bus.$emit("show_alert", { message: err_msg, type: "warning" });
        } else if (res.data.code === 303) {
          this.$refs.addStudentBtn.innerText = "Add All To Class";
          this.showError = true;
          let err_msg = Object.keys(res.data.data).length
            ? Object.keys(res.data.data)[0]
            : "Student already added";
          this.$bus.$emit("show_alert", { message: err_msg, type: "warning" });
        } else {
          this.$refs.addStudentBtn.innerText = "Add All To Class";
          this.showError = true;
          let err_msg = res.data.data
            ? res.data.data
            : "An error occured. Try again!";
          this.$bus.$emit("show_alert", { message: err_msg, type: "warning" });
        }
      });
    },

    getClassesAction() {
      let action;
      switch (this.account_type) {
        case "teacher":
          action = this.getClasses;
          break;
        default:
          action = this.getSchoolClasses;
          break;
      }
      action().then((res) => {
        this.classes = res.data;
        if (this.account_type == "school") {
          let all = [];
          res.data.forEach((group) => {
            all.push(...group.classes);
          });
          this.classes = all;

          if (this.classes.length == 0) this.getClassesAction();
          else return false;
        }
      });
    },

    checkClassValidity() {
      if (this.account_type === "teacher") {
        this.verifyClassStatus(Number(this.class_name))
          .then((response) =>
            response.data === false
              ? (this.is_class_valid = false)
              : (this.is_class_valid = true)
          )
          .catch((err) => console.log(err));
      } else this.is_class_valid = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group {
  width: 50% !important;

  @include breakpoint_max(md) {
    width: 75% !important;
  }

  @include breakpoint_max(sm) {
    width: 100% !important;
  }
}
</style>
